(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initGroup(group) {
      const track = group.querySelector('[data-track]');
      const dotsWrap = group.querySelector('[data-dots]');
      const prev = group.querySelector('[data-prev]');
      const next = group.querySelector('[data-next]');
      if (!track) return null;

      const cards = Array.from(track.querySelectorAll('.nbs-card'));
      if (!cards.length) return null;

      const dots = [];
      let dotsInner = null;
      let layoutRaf = 0;

      const MAX_DOTS = 5;
      const DOT = 7;
      const DOT_GAP = 7;
      const DOT_STEP = DOT + DOT_GAP;

      const getGap = () => {
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0');
        return Number.isFinite(gap) ? gap : 0;
      };
      const getStep = () => Math.max(1, cards[0].getBoundingClientRect().width + getGap());
      const getMaxIndex = () => Math.max(0, Math.ceil(Math.max(0, track.scrollWidth - track.clientWidth - 1) / getStep()));
      const getActiveIndex = () => Math.max(0, Math.round(track.scrollLeft / getStep()));

      /* build one dot per scroll position (not per card) */
      const buildDots = () => {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        dots.length = 0;
        dotsInner = document.createElement('div');
        dotsInner.className = 'nbs__dots-inner';
        const count = getMaxIndex() + 1;
        for (let i = 0; i < count; i++) {
          const btn = document.createElement('button');
          btn.className = 'nbs__dot' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Scroll to position ' + (i + 1));
          btn.addEventListener('click', () => goTo(i));
          dotsInner.appendChild(btn);
          dots.push(btn);
        }
        dotsWrap.appendChild(dotsInner);
        const visibleDots = Math.min(count, MAX_DOTS);
        dotsWrap.style.width = (visibleDots * DOT + (visibleDots - 1) * DOT_GAP) + 'px';
      };

      const updateDots = (idx) => {
        const pages = dots.length;
        let start = 0;
        if (pages > MAX_DOTS) {
          start = Math.min(Math.max(idx - 2, 0), pages - MAX_DOTS);
        }
        if (dotsInner) dotsInner.style.transform = 'translateX(' + -(start * DOT_STEP) + 'px)';
        dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === idx);
          d.classList.remove('nbs__dot--sm', 'nbs__dot--xs');
          if (pages > MAX_DOTS) {
            const rel = i - start;
            if (start > 0 && rel === 0) d.classList.add('nbs__dot--xs');
            else if (start > 0 && rel === 1) d.classList.add('nbs__dot--sm');
            if (start + MAX_DOTS < pages && rel === MAX_DOTS - 1) d.classList.add('nbs__dot--xs');
            else if (start + MAX_DOTS < pages && rel === MAX_DOTS - 2) d.classList.add('nbs__dot--sm');
          }
        });
      };

      const updateArrows = (idx, max) => {
        const atStart = idx <= 0;
        const atEnd = idx >= max;
        if (prev) {
          prev.classList.toggle('nbs__arrow--disabled', atStart);
          prev.disabled = atStart;
          prev.setAttribute('aria-disabled', String(atStart));
        }
        if (next) {
          next.classList.toggle('nbs__arrow--disabled', atEnd);
          next.disabled = atEnd;
          next.setAttribute('aria-disabled', String(atEnd));
        }
      };

      const update = () => {
        const max = getMaxIndex();
        const idx = Math.min(getActiveIndex(), max);
        updateDots(idx);
        updateArrows(idx, max);
      };

      const goTo = (index) => {
        const max = getMaxIndex();
        const idx = Math.max(0, Math.min(index, max));
        track.scrollTo({ left: getStep() * idx, behavior: 'smooth' });
      };

      const refresh = (resetPosition = false) => {
        if (layoutRaf) cancelAnimationFrame(layoutRaf);
        layoutRaf = requestAnimationFrame(() => {
          if (resetPosition) track.scrollTo({ left: 0, behavior: 'auto' });
          buildDots();
          update();
          layoutRaf = 0;
        });
      };

      if (prev) prev.addEventListener('click', () => goTo(getActiveIndex() - 1));
      if (next) next.addEventListener('click', () => goTo(getActiveIndex() + 1));

      let raf;
      track.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });

      window.addEventListener('resize', () => {
        if (group.classList.contains('nbs__group--active')) refresh(false);
      });

      /* defer build until layout is complete so offsetWidth is accurate */
      if (group.classList.contains('nbs__group--active')) refresh(false);

      return { refresh };
    }

    function initSection(section) {
      if (section.dataset.nbsInit === 'true') return;

      const tabs = Array.from(section.querySelectorAll('.nbs__tab'));
      const groups = Array.from(section.querySelectorAll('.nbs__group'));
      const groupControllers = new Map();

      groups.forEach((group) => {
        groupControllers.set(group, initGroup(group));
      });

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => { t.classList.remove('nbs__tab--active'); t.setAttribute('aria-selected', 'false'); });
          tab.classList.add('nbs__tab--active');
          tab.setAttribute('aria-selected', 'true');

          const target = tab.dataset.tab;
          groups.forEach((g) => {
            const isTarget = g.dataset.group === target;
            g.classList.toggle('nbs__group--active', isTarget);
            if (isTarget) {
              const controller = groupControllers.get(g);
              if (controller) controller.refresh(true);
            }
          });
        });
      });

      section.dataset.nbsInit = 'true';
    }

    const run = () => document.querySelectorAll('.nbs[data-section-id]').forEach(initSection);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-book-preview"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBook(root) {
      var book = root.querySelector('[data-book]');
      if (!book) return;
      var leaves = Array.prototype.slice.call(book.querySelectorAll('[data-leaf]'));
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var sheets = leaves.length;
      if (!sheets) return;

      var totalPages = parseInt(book.getAttribute('data-total'), 10) || sheets * 2;
      var maxSpread = Math.ceil(totalPages / 2) - 1; // last visible spread index
      if (maxSpread < 0) maxSpread = 0;

      var spread = 0; // current spread index = number of turned leaves

      function render() {
        for (var i = 0; i < sheets; i++) {
          var flipped = i < spread;
          leaves[i].classList.toggle('is-flipped', flipped);
          leaves[i].style.zIndex = flipped ? String(i + 1) : String(sheets - i);
        }
        var showEndingState = totalPages >= 6 && spread === maxSpread;
        book.classList.toggle('is-ending', showEndingState);
        if (prev) prev.disabled = spread <= 0;
        if (next) next.disabled = spread >= maxSpread;
      }

      // Keep the leaf currently mid-turn above every other leaf so the flip is visible.
      function turn(leaf) {
        if (!leaf) {
          render();
          return;
        }
        leaf.style.zIndex = String(sheets + 1);
        var done = function () {
          leaf.removeEventListener('transitionend', done);
          render();
        };
        leaf.addEventListener('transitionend', done);
        render();
        leaf.style.zIndex = String(sheets + 1);
      }

      if (next) {
        next.addEventListener('click', function () {
          if (spread < maxSpread) {
            var leaf = leaves[spread];
            spread++;
            turn(leaf);
          }
        });
      }
      if (prev) {
        prev.addEventListener('click', function () {
          if (spread > 0) {
            spread--;
            var leaf = leaves[spread];
            turn(leaf);
          }
        });
      }

      render();
    }

    function initAll() {
      document.querySelectorAll('.nbp').forEach(initBook);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.nbp');
      if (root) initBook(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-community-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(root) {
      if (!root || root.dataset.njcInit === 'true') return;

      var form = root.querySelector('.njc__form');
      if (!form) {
        root.dataset.njcInit = 'true';
        return;
      }

      var scriptUrl = (form.getAttribute('data-script-url') || '').trim();
      if (!scriptUrl) {
        root.dataset.njcInit = 'true';
        return;
      }

      var submitBtn = form.querySelector('.njc__btn--submit');
      var emailInput = form.querySelector('input[name="contact[email]"]');
      var asyncMsg = form.querySelector('[data-async-msg]');
      var successMessage = form.getAttribute('data-success-message') || 'Thanks! You are subscribed.';
      var errorMessage = form.getAttribute('data-error-message') || 'Could not subscribe right now. Please try again.';
      var isSubmitting = false;

      function showMessage(text, isError) {
        if (!asyncMsg) return;
        asyncMsg.textContent = text;
        asyncMsg.classList.remove('njc__form-msg--error', 'njc__form-msg--success');
        asyncMsg.classList.add(isError ? 'njc__form-msg--error' : 'njc__form-msg--success');
        asyncMsg.hidden = false;
      }

      form.addEventListener('submit', function (event) {
        if (!scriptUrl) return;

        event.preventDefault();
        if (isSubmitting) return;

        if (!emailInput || !emailInput.checkValidity()) {
          if (emailInput) emailInput.reportValidity();
          return;
        }

        isSubmitting = true;
        if (submitBtn) submitBtn.disabled = true;

        var payload = new URLSearchParams();
        payload.append('email', emailInput.value.trim());
        payload.append('source', 'shopify-community-signup');
        payload.append('shop', window.location.hostname);
        payload.append('section_id', root.id || '');
        payload.append('timestamp', new Date().toISOString());

        fetch(scriptUrl, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
          body: payload.toString()
        }).then(function () {
          form.reset();
          showMessage(successMessage, false);
        }).catch(function () {
          showMessage(errorMessage, true);
        }).finally(function () {
          isSubmitting = false;
          if (submitBtn) submitBtn.disabled = false;
        });
      });

      root.dataset.njcInit = 'true';
    }

    function initAll() {
      document.querySelectorAll('.njc').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.njc');
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.fnew');
    sections.forEach(function (root) {
      if (root.dataset.fnewInit) return;
      root.dataset.fnewInit = '1';

      var titles = root.querySelectorAll('.fnew__col-head');
      titles.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Accordion behaviour only applies on mobile widths.
          if (window.matchMedia('(min-width: 769px)').matches) return;
          var col = btn.closest('.fnew__col');
          var isOpen = col.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initNewHeader(root) {
      if (!root || root.dataset.ready === 'true') return;

      var hoverQuery = window.matchMedia('(min-width: 1100px) and (hover: hover) and (pointer: fine)');
      var megaItems = Array.prototype.slice.call(root.querySelectorAll('[data-mega-item]'));
      var megaTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-mega-trigger]'));
      var mobileWrap = root.querySelector('[data-mobile-header]');
      var openBtn = mobileWrap && mobileWrap.querySelector('[data-drawer-open]');
      var closeBtn = mobileWrap && mobileWrap.querySelector('[data-drawer-close]');
      var backdrop = mobileWrap && mobileWrap.querySelector('[data-drawer-backdrop]');
      var drawer = mobileWrap && mobileWrap.querySelector('.new-header__drawer');
      var mobileToggles = mobileWrap ? Array.prototype.slice.call(mobileWrap.querySelectorAll('[data-mobile-menu-toggle]')) : [];
      var closeTimer;
      var suppressFocusOpen = false;
      var previousBodyOverflow = '';

      function getPanel(trigger) {
        var panelId = trigger && trigger.getAttribute('aria-controls');
        return panelId ? document.getElementById(panelId) : null;
      }

      function closeMegaMenus(options) {
        var settings = options || {};
        window.clearTimeout(closeTimer);
        megaTriggers.forEach(function (trigger) {
          var panel = getPanel(trigger);
          var wasOpen = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
          }
          if (settings.returnFocus && wasOpen) {
            suppressFocusOpen = true;
            trigger.focus({ preventScroll: true });
            window.setTimeout(function () {
              suppressFocusOpen = false;
            }, 0);
          }
        });
        root.classList.remove('has-open-mega');
      }

      function openMegaMenu(trigger) {
        var panel = getPanel(trigger);
        if (!panel) return;
        window.clearTimeout(closeTimer);
        megaTriggers.forEach(function (otherTrigger) {
          var otherPanel = getPanel(otherTrigger);
          var isCurrent = otherTrigger === trigger;
          otherTrigger.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
          if (otherPanel) {
            otherPanel.classList.toggle('is-open', isCurrent);
            otherPanel.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
          }
        });
        root.classList.add('has-open-mega');
      }

      function scheduleMegaClose() {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(function () {
          closeMegaMenus();
        }, 150);
      }

      megaItems.forEach(function (item) {
        var trigger = item.querySelector('[data-mega-trigger]');
        if (!trigger) return;

        item.addEventListener('pointerenter', function () {
          if (hoverQuery.matches) openMegaMenu(trigger);
        });
        item.addEventListener('pointerleave', function () {
          if (hoverQuery.matches) scheduleMegaClose();
        });
        item.addEventListener('focusin', function () {
          if (suppressFocusOpen) return;
          openMegaMenu(trigger);
        });
        item.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!item.contains(document.activeElement)) scheduleMegaClose();
          }, 0);
        });
      });

      megaTriggers.forEach(function (trigger) {
        if (trigger.tagName === 'A') return;
        trigger.addEventListener('click', function () {
          if (trigger.getAttribute('aria-expanded') === 'true') {
            closeMegaMenus();
          } else {
            openMegaMenu(trigger);
          }
        });
      });

      function closeMobilePanels(exceptToggle) {
        mobileToggles.forEach(function (toggle) {
          if (toggle === exceptToggle) return;
          var panel = getPanel(toggle);
          toggle.setAttribute('aria-expanded', 'false');
          if (panel) {
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
            panel.inert = true;
          }
        });
      }

      mobileToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var panel = getPanel(toggle);
          if (!panel) return;
          var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
          closeMobilePanels(toggle);
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          panel.classList.toggle('is-open', willOpen);
          panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
          panel.inert = !willOpen;
        });
      });

      function openDrawer() {
        if (!mobileWrap || !drawer) return;
        closeMegaMenus();
        previousBodyOverflow = document.body.style.overflow;
        mobileWrap.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        window.setTimeout(function () {
          drawer.focus();
        }, 20);
      }

      function closeDrawer(options) {
        var settings = options || {};
        if (!mobileWrap || !drawer) return;
        mobileWrap.classList.remove('is-open');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
        drawer.setAttribute('aria-hidden', 'true');
        closeMobilePanels();
        document.body.style.overflow = previousBodyOverflow;
        if (settings.returnFocus && openBtn) openBtn.focus();
      }

      function trapDrawerFocus(event) {
        if (event.key !== 'Tab' || !mobileWrap || !mobileWrap.classList.contains('is-open')) return;
        var focusable = Array.prototype.slice.call(
          drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
        ).filter(function (element) {
          return !element.closest('[inert]') && element.offsetParent !== null;
        });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', function () { closeDrawer({ returnFocus: true }); });
      if (backdrop) backdrop.addEventListener('click', function () { closeDrawer({ returnFocus: true }); });

      if (mobileWrap) {
        mobileWrap.querySelectorAll('[data-drawer-link]').forEach(function (link) {
          link.addEventListener('click', function () { closeDrawer(); });
        });
      }

      document.addEventListener('pointerdown', function (event) {
        if (!root.contains(event.target)) closeMegaMenus();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          if (mobileWrap && mobileWrap.classList.contains('is-open')) {
            closeDrawer({ returnFocus: true });
          } else {
            closeMegaMenus({ returnFocus: true });
          }
        }
        trapDrawerFocus(event);
      });

      window.addEventListener('resize', function () {
        if (window.matchMedia('(min-width: 1100px)').matches) {
          closeDrawer();
        } else {
          closeMegaMenus();
        }
      });

      root.dataset.ready = 'true';
    }

    function run() {
      document.querySelectorAll('[data-new-header]').forEach(function (header) {
        initNewHeader(header);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero-banners"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.hero-banners[data-section-id]');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      const track = section.querySelector('[data-track]');
      if (!track) return;

      const slides = Array.from(track.querySelectorAll('.hero-banners__card'));
      const dots = Array.from(section.querySelectorAll('[data-dot]'));
      const prev = section.querySelector('[data-prev]');
      const next = section.querySelector('[data-next]');

      let activeIndex = 0;
      let isDragging = false;
      let startX = 0;
      let deltaX = 0;
      let videoLoadingEnabled = false;

      const getGap = () => {
        const style = window.getComputedStyle(track);
        return parseFloat(style.columnGap || style.gap || '0');
      };

      const getSlideOffset = () => {
        const first = slides[0];
        return first.offsetWidth + getGap();
      };

      const updateDots = () => {
        dots.forEach((dot, idx) => {
          dot.classList.toggle('is-active', idx === activeIndex);
        });
      };

      const updateVideoPlayback = () => {
        slides.forEach((slide, slideIndex) => {
          slide.querySelectorAll('video').forEach((video) => {
            const shouldPlay = slideIndex === activeIndex && window.getComputedStyle(video).display !== 'none';
            if (shouldPlay && videoLoadingEnabled) window.ShortStuffVideo?.play(video);
            else window.ShortStuffVideo?.pause(video);
          });
        });
      };

      const getMaxOffset = () => {
        const stageEl = section.querySelector('.hero-banners__stage');
        const stagePadX = parseFloat(getComputedStyle(stageEl).paddingLeft);
        const stageInnerWidth = stageEl.clientWidth - stagePadX * 2;
        const totalTrackWidth = slides.length * slides[0].offsetWidth + (slides.length - 1) * getGap();
        return Math.max(0, totalTrackWidth - stageInnerWidth);
      };

      const goTo = (index) => {
        if (index < 0) activeIndex = slides.length - 1;
        else if (index >= slides.length) activeIndex = 0;
        else activeIndex = index;

        let offset = getSlideOffset() * activeIndex;
        if (activeIndex === slides.length - 1) {
          offset = getMaxOffset();
        }
        track.style.transform = `translate3d(${-offset}px, 0, 0)`;
        updateDots();
        updateVideoPlayback();
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const idx = Number(dot.getAttribute('data-dot'));
          goTo(idx);
        });
      });

      if (prev) prev.addEventListener('click', () => goTo(activeIndex - 1));
      if (next) next.addEventListener('click', () => goTo(activeIndex + 1));

      track.addEventListener('touchstart', (e) => {
        isDragging = true;
        startX = e.touches[0].clientX;
        deltaX = 0;
      }, { passive: true });

      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        deltaX = e.touches[0].clientX - startX;
      }, { passive: true });

      track.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        const threshold = Math.max(50, slides[0].offsetWidth * 0.1);
        if (deltaX <= -threshold) goTo(activeIndex + 1);
        else if (deltaX >= threshold) goTo(activeIndex - 1);
        else goTo(activeIndex);
      });

      window.addEventListener('resize', () => goTo(activeIndex));
      goTo(0);

      const enableVideoLoading = () => {
        const start = () => {
          videoLoadingEnabled = true;
          updateVideoPlayback();
        };
        if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 1200 });
        else window.setTimeout(start, 250);
      };

      if (document.readyState === 'complete') enableVideoLoading();
      else window.addEventListener('load', enableVideoLoading, { once: true });
      section.dataset.initialized = 'true';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-reviews-logos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initReviews(root) {
      var track = root.querySelector('[data-track]');
      if (!track) return;
      var inner = root.querySelector('[data-track-inner]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-dot]'));
      var dotsInner = root.querySelector('[data-dots-inner]');
      var dotsWrap = root.querySelector('[data-dots]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var index = 0;
      var timer = null;

      var MAX_DOTS = 5;
      var DOT = 7;
      var DOT_GAP = 7;
      var DOT_STEP = DOT + DOT_GAP;
      if (dotsWrap && dots.length) {
        var visibleDots = Math.min(dots.length, MAX_DOTS);
        dotsWrap.style.width = (visibleDots * DOT + (visibleDots - 1) * DOT_GAP) + 'px';
      }

      function show(i) {
        index = (i + slides.length) % slides.length;
        if (inner) inner.style.transform = 'translateX(' + (-index * 100) + '%)';
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
        });
        var pages = dots.length;
        var start = 0;
        if (pages > MAX_DOTS) {
          start = Math.min(Math.max(index - 2, 0), pages - MAX_DOTS);
        }
        if (dotsInner) dotsInner.style.transform = 'translateX(' + -(start * DOT_STEP) + 'px)';
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === index);
          d.classList.remove('nrl__dot--sm', 'nrl__dot--xs');
          if (pages > MAX_DOTS) {
            var rel = n - start;
            if (start > 0 && rel === 0) d.classList.add('nrl__dot--xs');
            else if (start > 0 && rel === 1) d.classList.add('nrl__dot--sm');
            if (start + MAX_DOTS < pages && rel === MAX_DOTS - 1) d.classList.add('nrl__dot--xs');
            else if (start + MAX_DOTS < pages && rel === MAX_DOTS - 2) d.classList.add('nrl__dot--sm');
          }
        });
      }

      function go(step) {
        show(index + step);
      }

      if (prev) prev.addEventListener('click', function () { go(-1); restart(); });
      if (next) next.addEventListener('click', function () { go(1); restart(); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          show(parseInt(d.getAttribute('data-index'), 10));
          restart();
        });
      });

      function start() {
        if (root.getAttribute('data-autoplay') !== 'true') return;
        var secs = parseFloat(root.getAttribute('data-autoplay-speed')) || 5;
        timer = window.setInterval(function () { go(1); }, secs * 1000);
      }

      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }

      function restart() {
        stop();
        start();
      }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      show(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('.nrl').forEach(initReviews);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.nrl');
      if (root) initReviews(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-shop-collections"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initNav(root) {
      var row = root.querySelector('.nsc__row');
      var nav = root.querySelector('[data-nav]');
      if (!row || !nav) return;

      var dotsWrap = nav.querySelector('[data-dots]');
      var prev = nav.querySelector('[data-prev]');
      var next = nav.querySelector('[data-next]');
      var cards = Array.prototype.slice.call(row.querySelectorAll('.nsc__card'));
      if (!cards.length) return;

      var dots = [];

      function getGap() {
        return parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || '32') || 0;
      }
      function getStep() {
        return cards[0].offsetWidth + getGap();
      }
      function getMax() {
        return Math.max(0, Math.ceil((row.scrollWidth - row.clientWidth - 1) / getStep()));
      }
      function activeIndex() {
        return Math.round(row.scrollLeft / getStep());
      }

      function goTo(i) {
        var max = getMax();
        var idx = Math.max(0, Math.min(i, max));
        row.scrollTo({ left: getStep() * idx, behavior: 'smooth' });
      }

      function update() {
        var max = getMax();
        var idx = Math.min(activeIndex(), max);
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('is-active', i === idx);
        }
        if (prev) prev.classList.toggle('nsc__nav-arrow--disabled', idx <= 0);
        if (next) next.classList.toggle('nsc__nav-arrow--disabled', idx >= max);
      }

      function buildDots() {
        var max = getMax();
        if (max <= 0) {
          nav.hidden = true;
          return;
        }
        nav.hidden = false;
        dotsWrap.innerHTML = '';
        dots = [];
        for (var i = 0; i <= max; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'nsc__dot' + (i === 0 ? ' is-active' : '');
          b.setAttribute('aria-label', 'Scroll to position ' + (i + 1));
          (function (index) {
            b.addEventListener('click', function () { goTo(index); });
          })(i);
          dotsWrap.appendChild(b);
          dots.push(b);
        }
        update();
      }

      if (prev) prev.addEventListener('click', function () { goTo(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { goTo(activeIndex() + 1); });

      var raf;
      row.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      }, { passive: true });

      var rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(buildDots, 150);
      });

      requestAnimationFrame(buildDots);
    }

    function initAll() {
      document.querySelectorAll('.nsc').forEach(initNav);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.nsc');
      if (root) initNav(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-shop-print"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.nspInit === 'true') return;
      const track = section.querySelector('[data-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('.nsp__card'));
      if (!cards.length) return;
      const dotWraps = Array.from(section.querySelectorAll('[data-dots]'));
      const prevs = Array.from(section.querySelectorAll('[data-prev]'));
      const nexts = Array.from(section.querySelectorAll('[data-next]'));

      const step = () => {
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return cards[0].offsetWidth + gap;
      };

      const pageCount = () => {
        const visible = Math.max(1, Math.round(track.clientWidth / step()));
        return Math.max(1, cards.length - visible + 1);
      };

      const update = () => {
        const pages = pageCount();
        const idx = Math.max(0, Math.min(Math.round(track.scrollLeft / step()), pages - 1));
        dotWraps.forEach((w) => {
          Array.from(w.children).forEach((d, i) => d.classList.toggle('is-active', i === idx));
        });
        const max = track.scrollWidth - track.clientWidth - 1;
        prevs.forEach((p) => p.classList.toggle('nsp__arrow--disabled', track.scrollLeft <= 1));
        nexts.forEach((n) => n.classList.toggle('nsp__arrow--disabled', track.scrollLeft >= max));
      };

      const buildDots = () => {
        const pages = pageCount();
        dotWraps.forEach((w) => {
          w.innerHTML = '';
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.className = 'nsp__dot';
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to position ' + (i + 1));
            b.addEventListener('click', () => track.scrollTo({ left: step() * i, behavior: 'smooth' }));
            w.appendChild(b);
          }
        });
        update();
      };

      prevs.forEach((p) => p.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
      nexts.forEach((n) => n.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', buildDots);

      requestAnimationFrame(buildDots);
      section.dataset.nspInit = 'true';
    }

    const run = () => document.querySelectorAll('.nsp[data-section-id]').forEach(initSection);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-short-stories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.nssInit === 'true') return;
      const track = section.querySelector('[data-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('.nss__cardwrap'));
      if (!cards.length) return;
      const dotWrap = section.querySelector('[data-dots]');
      const prev = section.querySelector('[data-prev]');
      const next = section.querySelector('[data-next]');

      const MAX_DOTS = 5;
      const DOT = 7;
      const DOT_GAP = 6;
      const DOT_STEP = DOT + DOT_GAP;
      let dotsInner = null;
      let dotEls = [];

      const step = () => {
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return cards[0].offsetWidth + gap;
      };

      const pageCount = () => {
        const visible = Math.max(1, Math.round(track.clientWidth / step()));
        return Math.max(1, cards.length - visible + 1);
      };

      const update = () => {
        const pages = pageCount();
        const idx = Math.max(0, Math.min(Math.round(track.scrollLeft / step()), pages - 1));
        if (dotsInner && dotEls.length) {
          let start = 0;
          if (pages > MAX_DOTS) {
            start = Math.min(Math.max(idx - 2, 0), pages - MAX_DOTS);
          }
          dotsInner.style.transform = 'translateX(' + -(start * DOT_STEP) + 'px)';
          dotEls.forEach((d, i) => {
            d.classList.toggle('is-active', i === idx);
            d.classList.remove('nss__dot--sm', 'nss__dot--xs');
            if (pages > MAX_DOTS) {
              const rel = i - start;
              if (start > 0 && rel === 0) d.classList.add('nss__dot--xs');
              else if (start > 0 && rel === 1) d.classList.add('nss__dot--sm');
              if (start + MAX_DOTS < pages && rel === MAX_DOTS - 1) d.classList.add('nss__dot--xs');
              else if (start + MAX_DOTS < pages && rel === MAX_DOTS - 2) d.classList.add('nss__dot--sm');
            }
          });
        }
        const max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.classList.toggle('nss__arrow--disabled', track.scrollLeft <= 1);
        if (next) next.classList.toggle('nss__arrow--disabled', track.scrollLeft >= max);
      };

      const buildDots = () => {
        if (!dotWrap) return;
        const pages = pageCount();
        dotWrap.innerHTML = '';
        dotsInner = document.createElement('div');
        dotsInner.className = 'nss__dots-inner';
        dotEls = [];
        for (let i = 0; i < pages; i++) {
          const b = document.createElement('button');
          b.className = 'nss__dot';
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to position ' + (i + 1));
          b.addEventListener('click', () => track.scrollTo({ left: step() * i, behavior: 'smooth' }));
          dotsInner.appendChild(b);
          dotEls.push(b);
        }
        dotWrap.appendChild(dotsInner);
        const visibleDots = Math.min(pages, MAX_DOTS);
        dotWrap.style.width = (visibleDots * DOT + (visibleDots - 1) * DOT_GAP) + 'px';
        update();
      };

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', buildDots);

      requestAnimationFrame(buildDots);
      section.dataset.nssInit = 'true';
    }

    const run = () => document.querySelectorAll('.nss[data-section-id]').forEach(initSection);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-watch-shop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSection(section) {
      if (section.dataset.nwsInit === 'true') return;
      const track = section.querySelector('[data-track]');
      if (!track) return;
      const cards = Array.from(track.querySelectorAll('.nws__card'));
      if (!cards.length) return;
      const dotWraps = Array.from(section.querySelectorAll('[data-dots]'));
      const prevs = Array.from(section.querySelectorAll('[data-prev]'));
      const nexts = Array.from(section.querySelectorAll('[data-next]'));
      const autoScrollEnabled = section.dataset.autoScrollEnabled === 'true';
      const autoScrollIntervalMs = (parseInt(section.dataset.autoScrollInterval, 10) || 4) * 1000;
      let autoTimer = null;

      const MAX_DOTS = 5;
      const DOT = 7;
      const DOT_GAP = 7;
      const DOT_STEP = DOT + DOT_GAP;
      const dotState = [];

      const step = () => {
        const styles = getComputedStyle(track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return cards[0].offsetWidth + gap;
      };

      /* number of scroll positions (pages), not one per card */
      const pageCount = () => {
        const visible = Math.max(1, Math.round(track.clientWidth / step()));
        return Math.max(1, cards.length - visible + 1);
      };

      const update = () => {
        const pages = pageCount();
        const idx = Math.max(0, Math.min(Math.round(track.scrollLeft / step()), pages - 1));
        let start = 0;
        if (pages > MAX_DOTS) {
          start = Math.min(Math.max(idx - 2, 0), pages - MAX_DOTS);
        }
        dotState.forEach((s) => {
          if (s.inner) s.inner.style.transform = 'translateX(' + -(start * DOT_STEP) + 'px)';
          s.els.forEach((d, i) => {
            d.classList.toggle('is-active', i === idx);
            d.classList.remove('nws__dot--sm', 'nws__dot--xs');
            if (pages > MAX_DOTS) {
              const rel = i - start;
              if (start > 0 && rel === 0) d.classList.add('nws__dot--xs');
              else if (start > 0 && rel === 1) d.classList.add('nws__dot--sm');
              if (start + MAX_DOTS < pages && rel === MAX_DOTS - 1) d.classList.add('nws__dot--xs');
              else if (start + MAX_DOTS < pages && rel === MAX_DOTS - 2) d.classList.add('nws__dot--sm');
            }
          });
        });
        const max = track.scrollWidth - track.clientWidth - 1;
        prevs.forEach((p) => p.classList.toggle('nws__arrow--disabled', track.scrollLeft <= 1));
        nexts.forEach((n) => n.classList.toggle('nws__arrow--disabled', track.scrollLeft >= max));
      };

      const currentIndex = () => {
        const pages = pageCount();
        return Math.max(0, Math.min(Math.round(track.scrollLeft / step()), pages - 1));
      };

      const goToIndex = (index) => {
        track.scrollTo({ left: step() * index, behavior: 'smooth' });
      };

      const stopAutoScroll = () => {
        if (autoTimer) {
          window.clearInterval(autoTimer);
          autoTimer = null;
        }
      };

      const startAutoScroll = () => {
        stopAutoScroll();
        if (!autoScrollEnabled || pageCount() <= 1) return;
        autoTimer = window.setInterval(() => {
          const pages = pageCount();
          if (pages <= 1) return;
          const idx = currentIndex();
          if (idx >= pages - 1) {
            goToIndex(0);
          } else {
            goToIndex(idx + 1);
          }
        }, autoScrollIntervalMs);
      };

      const restartAutoScroll = () => {
        if (!autoScrollEnabled) return;
        startAutoScroll();
      };

      const buildDots = () => {
        const pages = pageCount();
        dotState.length = 0;
        dotWraps.forEach((w) => {
          w.innerHTML = '';
          const inner = document.createElement('div');
          inner.className = 'nws__dots-inner';
          const els = [];
          for (let i = 0; i < pages; i++) {
            const b = document.createElement('button');
            b.className = 'nws__dot';
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to position ' + (i + 1));
            b.addEventListener('click', () => {
              goToIndex(i);
              restartAutoScroll();
            });
            inner.appendChild(b);
            els.push(b);
          }
          w.appendChild(inner);
          const visibleDots = Math.min(pages, MAX_DOTS);
          w.style.width = (visibleDots * DOT + (visibleDots - 1) * DOT_GAP) + 'px';
          dotState.push({ inner: inner, els: els });
        });
        update();
        restartAutoScroll();
      };

      prevs.forEach((p) => p.addEventListener('click', () => {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
        restartAutoScroll();
      }));
      nexts.forEach((n) => n.addEventListener('click', () => {
        track.scrollBy({ left: step(), behavior: 'smooth' });
        restartAutoScroll();
      }));
      track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', buildDots);

      section.addEventListener('mouseenter', stopAutoScroll);
      section.addEventListener('mouseleave', startAutoScroll);
      section.addEventListener('focusin', stopAutoScroll);
      section.addEventListener('focusout', startAutoScroll);
      section.addEventListener('touchstart', stopAutoScroll, { passive: true });
      section.addEventListener('touchend', startAutoScroll, { passive: true });

      requestAnimationFrame(buildDots);
      section._nwsStopAutoScroll = stopAutoScroll;
      section.dataset.nwsInit = 'true';
    }

    const run = () => document.querySelectorAll('.nws[data-section-id]').forEach(initSection);
    document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', run) : run();

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('.nws[data-section-id]');
      if (!root && e.target.matches && e.target.matches('.nws[data-section-id]')) {
        root = e.target;
      }
      if (root && root._nwsStopAutoScroll) {
        root._nwsStopAutoScroll();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
